import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';
import { Calendar, ArrowRight, Eye } from 'lucide-react';

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/blog/posts').then(r => setPosts(r.data.items)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="mb-10">
        <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight">Blog Torr.pl</h1>
        <p className="text-muted-foreground mt-2">Aktualnosci, poradniki i wiedza o email marketingu i wysylce SMS</p>
      </div>
      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1,2,3].map(i => <Skeleton key={i} className="h-72 rounded-xl" />)}
        </div>
      ) : posts.length === 0 ? (
        <Card className="border-border/50 bg-card/80">
          <CardContent className="py-16 text-center">
            <p className="text-muted-foreground">Jeszcze nie opublikowano zadnych artykulow. Wrocic wkrotce!</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map(post => (
            <Link key={post.id} to={`/blog/${post.slug}`}>
              <Card className="border-border/50 bg-card/80 hover:shadow-lg transition-shadow duration-200 overflow-hidden h-full">
                {post.image_url && (
                  <div className="aspect-video bg-muted overflow-hidden">
                    <img src={post.image_url} alt={post.title} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                )}
                <CardContent className="pt-4 pb-5 px-5">
                  <div className="flex items-center gap-2 mb-2">
                    {post.tags?.map(t => <Badge key={t} variant="secondary" className="text-[10px]">{t}</Badge>)}
                  </div>
                  <h2 className="font-heading text-base font-semibold line-clamp-2 mb-2">{post.title}</h2>
                  <p className="text-xs text-muted-foreground line-clamp-3">{post.excerpt}</p>
                  <div className="flex items-center gap-3 mt-3 text-xs text-muted-foreground">
                    <div className="flex items-center gap-1"><Calendar className="h-3 w-3" />{post.published_at?.slice(0, 10)}</div>
                    <div className="flex items-center gap-1"><Eye className="h-3 w-3" />{post.views || 0}</div>
                    <span className="ml-auto text-primary flex items-center gap-1">Czytaj <ArrowRight className="h-3 w-3" /></span>
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
